export const menuItems = [
    {
        title: 'WHO WE ARE',
        subMenu: [
            { title: 'OVERVIEW', path: '/overview' },
            { title: 'BOARD OF DIRECTORS', path: '/board-of-directors' },
            { title: 'FRIENDS OF BEADS', path: '/friends-of-beads' },
            { title: 'PRESS', path: '/press' },
            { title: 'BEADS MENTORSHIP PROGRAM', path: '/mentorship-program' },
            { title: 'WOMEN\'S BEADING GROUPS', path: '/beading-groups' },
            { title: 'CHANGEMAKERS PROJECT', path: '/changemaker-projects' },
        ],
    },
    {
        title: 'WHAT WE DO',
        subMenu: [
            { title: 'OVERVIEW', path: '/overview-tab' },
            { title: 'BEADS INTERN PROGRAM', path: '/interns-program' },
            { title: 'COMING OF AGE', path: '/coming-of-age' },
            { title: 'TEACHERS TRAINING', path: '/teachers-training' },
            { title: 'LIBRARY DEVELOPMENTS', path: '/library-development' },
            { title: 'SCHOOL SPONSORSHIP', path: '/school-sponsorships' },
            {
                title: 'CLIMATE CHANGE MAKERS IN SUB-SAHARAN AFRICA',
                path: 'https://climatechange-makers.netlify.app/',
                isExternal: true,
            },
            { title: 'FAMINE RELIEF', path: '/famine-relief' },
            { title: 'CAROL SUCCESS STORY AND COVID HELP', path: '/carol-success-story' },
        ],
    },
    { title: 'SUCCESS STORIES', path: '/success-stories', subMenu: [] },
    {
        title: 'BEADS HIGH SCHOOL',
        subMenu: [
            { title: 'OVERVIEW', path: '/tembea-overview' },
            { title: 'FUNDING NEEDS', path: '/funding-needs' },
        ],
    },
    {
        title: 'GET INVOLVED',
        subMenu: [
            { title: 'OVERVIEW', path: '/school-sponsorships' },
            { title: 'DONATIONS AND ALTERNATIVE GIFTS', path: '/donations-and-alternative-gifts' },
            { title: 'SPONSORS TRIPS', path: '/sponsors-trips' },
        ],
    },
    { title: 'NEWS', path: '/news', subMenu: [] },
    { title: 'CONTACT US', path: '/contact', subMenu: [] },
    { title: 'DONATE', path: '/donate', subMenu: [], button: true },
];